import React, { useRef, useState } from "react";
import TableDataRender from "../../../components/common/TableDataRender";
import {
  FaTrash,
  FaHamburger,
  FaPepperHot,
  FaPencilAlt,
  FaListUl,
  FaCheese,
  FaCartPlus,
} from "react-icons/fa";
import ModalWindow from "../../../components/ModalWindow";
import FormBurgerSizes from "./forms/FormBurgerSizes";
import { getData, postData } from "../../../services/api.service";
import {
  swalAlertDanger,
  swalAlertSuccess,
} from "../../../components/common/Alerts";
import FormBurgerToppings from "./forms/FormBurgerToppings";
import FormBurgerCheeses from "./forms/FormBurgerCheeses";
import FormBurgerExtras from "./forms/FormBurgerExtras";
import FormEditBurger from "./forms/FormEditBurger";
import FormBurgerVarieties from "./forms/FormBurgerVarieties";

const AdminBurgers = ({ burgers, handleDelete, id_branch }) => {
  const tableRef = useRef();
  const [selectedBurger, setSelectedBurger] = useState([]);

  const [allSizes, setAllSizes] = useState([]);
  const [sizesBurger, setSizesBurger] = useState([]);

  const [allToppings, setAllToppings] = useState([]);
  const [toppingsBurger, setToppingsBurger] = useState([]);
  const [varietiesBurger, setVarietiesBurger] = useState([]);

  const [allCheeses, setAllCheeses] = useState([]);
  const [cheesesBurger, setCheesesBurger] = useState([]);

  const [allExtras, setAllExtras] = useState([]);
  const [extrasBurger, setExtrasBurger] = useState([]);

  const [showSizes, setShowSizes] = useState(false);
  const [showToppings, setShowToppings] = useState(false);
  const [showCheeses, setShowCheeses] = useState(false);
  const [showExtras, setShowExtras] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showVarieties, setShowVarieties] = useState(false);

  const columnMapping = {
    HAMBURGUESA: { key: "type_description", dataType: "text", align: "center" },
    PAPAS: {
      key: "side_fries_description",
      dataType: "text",
      align: "center",
    },
    TAMAÑOS: {
      key: "sizes",
      dataType: "text",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            handleGetSizesBurger(item);
          }}
          className="btn btn-warning"
          style={{ backgroundColor: "#E35E1E" }}
        >
          <FaHamburger />
        </button>
      ),
    },

    VARIEDADES: {
      key: "sizes",
      dataType: "text",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            handleGetBurguerVarieties(item);
          }}
          className="btn btn-warning"
        >
          <FaListUl />
        </button>
      ),
    },

    TOPPINGS: {
      key: "toppings",
      dataType: "text",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            handleGetToppingsBurger(item);
          }}
          className="btn btn-success"
        >
          <FaPepperHot />
        </button>
      ),
    },
    CHEESES: {
      key: "cheeses",
      dataType: "text",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            handleGetCheesesBurger(item);
          }}
          className="btn btn-warning"
        >
          <FaCheese />
        </button>
      ),
    },

    EXTRAS: {
      key: "extras",
      dataType: "text",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            handleGetExtrasBurger(item);
          }}
          className="btn btn-success"
        >
          <FaCartPlus />
        </button>
      ),
    },
    EDITAR: {
      key: "edit",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            setSelectedBurger(item);
            setShowModalEdit(true);
          }}
          className="btn btn-info"
        >
          <FaPencilAlt />
        </button>
      ),
    },
    ELIMINAR: {
      key: "delete",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            handleDelete(item);
          }}
          className="btn btn-danger"
        >
          <FaTrash />
        </button>
      ),
    },
  };

  const handleGetSizesBurger = async (item) => {
    const resSizes = await getData(
      `/api/get_burguer_sizes_by_type/${item.id}/${id_branch}`
    );
    const resAll = await getData(`/api/get_burguer_sizes/${id_branch}`);

    if (resSizes.status === 200 && resAll.status === 200) {
      setSizesBurger(resSizes.data.burger_sizes);
      setAllSizes(resAll.data.burger_sizes);
      setSelectedBurger(item);
      setShowSizes(true);
    } else {
      swalAlertDanger(
        "Error al obtener los tamaños de la hamburguesa",
        resSizes.msg || resAll.msg,
        () => {}
      );
    }
  };

  const handleUpdateSizes = async (data) => {
    postData("/api/admin/update_burguer_sizes", data).then((res) => {
      if (res.data.success) {
        swalAlertSuccess(
          "Tamaños de hamburguesa actualizados exitosamente",
          "",
          () => {
            setShowSizes(false);
          }
        );
      } else {
        swalAlertDanger(
          "Error al actualizar los tamaños de la hamburguesa",
          res.msg,
          () => {}
        );
      }
    });
  };

  const handleGetBurguerVarieties = async (item) => {
    const resVarieties = await getData(
      `/api/get_burger_varieties_by_type/${item.id}/${id_branch}`
    );
    if (resVarieties.status === 200) {
      setVarietiesBurger(resVarieties.data.burger_varieties);
      setSelectedBurger(item);
      setShowVarieties(true);
    }
  };

  const handleGetToppingsBurger = async (item) => {
    const resToppingsBurger = await getData(
      `/api/get_toppings_types_by_burguer_type/${item.id}/${id_branch}`
    );
    const resAllToppings = await getData(
      `/api/get_toppings_types/${id_branch}`
    );

    if (resToppingsBurger.status === 200 && resAllToppings.status === 200) {
      setToppingsBurger(resToppingsBurger.data.toppings_by_burguer_type);
      setAllToppings(resAllToppings.data.toppings_types);
      setSelectedBurger(item);
      setShowToppings(true);
    } else {
      swalAlertDanger(
        "Error al obtener los toppings de la hamburguesa",
        resToppingsBurger.msg || resAllToppings.msg,
        () => {}
      );
    }
  };

  const handleUpdateToppings = async (data) => {
    await postData("/api/admin/update_burguer_toppings", data).then((res) => {
      if (res.data.success) {
        swalAlertSuccess(
          "Toppings de hamburguesa actualizados exitosamente",
          "",
          () => {
            setShowToppings(false);
          }
        );
      } else {
        swalAlertDanger(
          "Error al actualizar los toppings de la hamburguesa",
          res.msg,
          () => {}
        );
      }
    });
  };

  const handleGetCheesesBurger = async (item) => {
    const resCheesesBurger = await getData(
      `/api/get_cheeses_types_by_burguer_type/${item.id}/${id_branch}`
    );
    const resAllCheeses = await getData(
      `/api/get_cheese_types/${id_branch}`
    );

    if (resCheesesBurger.status === 200 && resAllCheeses.status === 200) {
      setCheesesBurger(resCheesesBurger.data.cheeses_by_burguer_type);
      setAllCheeses(resAllCheeses.data.cheese_types);
      setSelectedBurger(item);
      setShowCheeses(true);
    } else {
      swalAlertDanger(
        "Error al obtener los quesos de la hamburguesa",
        resCheesesBurger.msg || resAllCheeses.msg,
        () => {}
      );
    }
  };

  const handleUpdateCheeses = async (data) => {
    await postData("/api/admin/update_burguer_cheeses", data).then((res) => {
      if (res.data.success) {
        swalAlertSuccess(
          "Quesos de hamburguesa actualizados exitosamente",
          "",
          () => {
            setShowCheeses(false);
          }
        );
      } else {
        swalAlertDanger(
          "Error al actualizar los quesos de la hamburguesa",
          res.msg,
          () => {}
        );
      }
    });
  };

  const handleGetExtrasBurger = async (item) => {
    const resExtrasBurger = await getData(
      `/api/get_extras_types_by_burguer_type/${item.id}/${id_branch}`
    );
    const resAllExtras = await getData(
      `/api/get_items_addons_by_side_item/1/${id_branch}`
    );

    if (resExtrasBurger.status === 200 && resAllExtras.status === 200) {
      setExtrasBurger(resExtrasBurger.data.extras_by_burguer_type);
      setAllExtras(resAllExtras.data);
      setSelectedBurger(item);
      setShowExtras(true);
    } else {
      swalAlertDanger(
        "Error al obtener los extras de la hamburguesa",
        resExtrasBurger.msg || resAllExtras.msg,
        () => {}
      );
    }
  };

  const handleUpdateExtras = async (data) => {
    await postData("/api/admin/update_burguer_extras", data).then((res) => {
      if (res.data.success) {
        swalAlertSuccess(
          "Extras de hamburguesa actualizados exitosamente",
          "",
          () => {
            setShowExtras(false);
          }
        );
      } else {
        swalAlertDanger(
          "Error al actualizar los extras de la hamburguesa",
          res.msg,
          () => {}
        );
      }
    });
  };

  const handleEditBurger = async (data) => {
    await postData("/api/admin/update_burguer_type", data).then((res) => {
      if (res.data.success) {
        swalAlertSuccess("Hamburguesa actualizada exitosamente", "", () => {
          setShowModalEdit(false);
          window.location.reload();
        });
      } else {
        swalAlertDanger(
          "Error al actualizar el tipo de hamburguesa",
          res.msg,
          () => {}
        );
      }
    });
  };

  return (
    <>
      <div>
        <TableDataRender
          data={burgers}
          columnMapping={columnMapping}
          tableRef={tableRef}
        />
      </div>
      <ModalWindow
        title={"Seleccionar tamaños"}
        body={
          <FormBurgerSizes
            selectedBurger={selectedBurger}
            sizesBurger={sizesBurger}
            allSizes={allSizes}
            handleSizes={handleUpdateSizes}
          />
        }
        modalOpen={showSizes}
        setModalOpen={setShowSizes}
        footer={
          "Selecciona los tamaños disponibles para este tipo de hamburguesa"
        }
      />
      <ModalWindow
        title={"Seleccionar variedades"}
        body={
          <FormBurgerVarieties
            id_branch={id_branch}
            selectedBurger={selectedBurger}
            varitiesBurger={varietiesBurger}
          />
        }
        modalOpen={showVarieties}
        setModalOpen={setShowVarieties}
        footer={
          "Selecciona las variedades disponibles para este tipo de hamburguesa"
        }
      />
      <ModalWindow
        title={"Seleccionar toppings"}
        body={
          <FormBurgerToppings
            selectedBurger={selectedBurger}
            allTopings={allToppings}
            burgerToppings={toppingsBurger}
            handleUpdateToppings={handleUpdateToppings}
          />
        }
        modalOpen={showToppings}
        setModalOpen={setShowToppings}
        footer={
          "Selecciona los toppings disponibles para este tipo de hamburguesa"
        }
      />
      <ModalWindow
        title={"Seleccionar quesos"}
        body={
          <FormBurgerCheeses
            selectedBurger={selectedBurger}
            allCheeses={allCheeses}
            burgerCheeses={cheesesBurger}
            handleUpdateCheeses={handleUpdateCheeses}
          />
        }
        modalOpen={showCheeses}
        setModalOpen={setShowCheeses}
        footer={
          "Selecciona los quesos disponibles para este tipo de hamburguesa"
        }
      />
      <ModalWindow
        title={"Seleccionar extras"}
        body={
          <FormBurgerExtras
            selectedBurger={selectedBurger}
            allExtras={allExtras}
            burgerExtras={extrasBurger}
            handleUpdateExtras={handleUpdateExtras}
          />
        }
        modalOpen={showExtras}
        setModalOpen={setShowExtras}
        footer={
          "Selecciona los extras disponibles para este tipo de hamburguesa"
        }
      />
      <ModalWindow
        body={
          <FormEditBurger
            selectedBurger={selectedBurger}
            handleEdit={handleEditBurger}
          />
        }
        modalOpen={showModalEdit}
        setModalOpen={setShowModalEdit}
        footer={"Edita los datos de la hamburguesa"}
      />
    </>
  );
};

export default AdminBurgers;
